export default "__VITE_ASSET__de384102__"